var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 38,
    viewBox: "0 0 47 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.4622 16.5C46.4622 19.6111 46.2902 22.2222 45.9462 24.3333C45.7168 26.4444 45.2008 28.2778 44.3981 29.8333C43.5954 31.5 42.4488 32.9444 40.958 34.1667C39.582 35.3889 37.8046 36.6667 35.6259 38L30.9818 32.5C32.7018 31.7222 34.0779 30.9444 35.1099 30.1667C36.2566 29.3889 37.1166 28.3889 37.69 27.1667C38.378 26.0556 38.7793 24.6111 38.894 22.8333C39.1233 21.1667 39.238 19.0556 39.238 16.5H29.2617V0H46.4622V16.5Z",
    fill: "url(#paint0_linear_249_915)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2005 16.5C17.2005 19.6111 17.0285 22.2222 16.6845 24.3333C16.4551 26.4444 15.9391 28.2778 15.1364 29.8333C14.3337 31.5 13.187 32.9444 11.6963 34.1667C10.3203 35.3889 8.5429 36.6667 6.36418 38L1.72005 32.5C3.4401 31.7222 4.81613 30.9444 5.84816 30.1667C6.99486 29.3889 7.85488 28.3889 8.42823 27.1667C9.11625 26.0556 9.51759 24.6111 9.63226 22.8333C9.8616 21.1667 9.97627 19.0556 9.97627 16.5H0V0H17.2005V16.5Z",
    fill: "url(#paint1_linear_249_915)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_249_915",
    x1: 28.5872,
    y1: -3.093,
    x2: 47.9123,
    y2: -2.91483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6F1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.364583,
    stopColor: "#F983E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739583,
    stopColor: "#B877FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2E9CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_249_915",
    x1: -0.674529,
    y1: -3.093,
    x2: 18.6506,
    y2: -2.91483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6F1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.364583,
    stopColor: "#F983E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739583,
    stopColor: "#B877FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2E9CD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/,,.2538ff62923e0d4fd9728e3ec74ea196.svg";
export { ForwardRef as ReactComponent };